import { authFetch } from './authFetch';

const API_BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api/mailvotes`
  : (process.env.NODE_ENV === 'development'
    ? 'http://localhost:5005/api/mailvotes'
    : 'https://doorknockserver-280072100489.us-central1.run.app/api/mailvotes');

const bridgeService = {
  /**
   * Send voter IDs from MailVotes to DoorNoc via bridge transfer.
   * Server reads userId from verified ID token and re-runs the purchase's
   * search to collect the full voter list. voterIds is only passed through
   * for the super-user/legacy path.
   */
  async sendToDoorNoc({ state, filters, purchaseId, voterIds }) {
    const body = { state, filters, purchaseId };
    if (Array.isArray(voterIds) && voterIds.length > 0) {
      body.voterIds = voterIds;
    }
    const response = await authFetch(`${API_BASE}/bridge/send-to-doornoc`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      const errText = await response.text().catch(() => '');
      throw new Error(`bridge send-to-doornoc failed (${response.status}): ${errText}`);
    }
    return response.json();
  }
};

export default bridgeService;
